import { render, staticRenderFns } from "./RegionSortTable.vue?vue&type=template&id=1c3bf174"
import script from "./RegionSortTable.vue?vue&type=script&lang=js"
export * from "./RegionSortTable.vue?vue&type=script&lang=js"
import style0 from "./RegionSortTable.vue?vue&type=style&index=0&id=1c3bf174&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c3bf174')) {
      api.createRecord('1c3bf174', component.options)
    } else {
      api.reload('1c3bf174', component.options)
    }
    module.hot.accept("./RegionSortTable.vue?vue&type=template&id=1c3bf174", function () {
      api.rerender('1c3bf174', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/region/components/RegionSortTable.vue"
export default component.exports